<template>
    <div>
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <!-- Valor Total do Contrato (destaque) -->
                            <div class="col-12 mb-3">
                                <div class="card card-stats" style="border-left: 4px solid #5e72e4;">
                                    <div class="card-body">
                                        <div class="row">
                                            <div class="col">
                                                <h6 class="card-title text-uppercase text-muted mb-0">Valor Total do Contrato</h6>
                                                <span class="h2 font-weight-bold mb-0" style="color: #5e72e4;"> {{ formatarDinheiro(dashboard.valorTotalContrato) }}</span>
                                                <p class="text-muted small mb-0 mt-1">Entrada + Prestações + Taxas</p>
                                            </div>
                                            <div class="col-auto">
                                                <div style="color: #5e72e4;">
                                                    <b-icon-cash-coin font-scale="2.5"></b-icon-cash-coin>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- Valor da Entrada -->
                            <div class="col-12 col-md-4 mb-3">
                                <div class="card card-stats">
                                    <div class="card-body">
                                        <div class="row">
                                            <div class="col">
                                                <h6 class="card-title text-uppercase text-muted mb-0">Valor da Entrada</h6>
                                                <span class="h3 font-weight-bold mb-0"> {{ formatarDinheiro(dashboard.valorTotalEntrada) }}</span>
                                            </div>
                                            <div class="col-auto">
                                                <div class="text-green">
                                                    <b-icon-cash-coin variant="success" font-scale="2"></b-icon-cash-coin>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- Valor das Prestações -->
                            <div class="col-12 col-md-4 mb-3">
                                <div class="card card-stats">
                                    <div class="card-body">
                                        <div class="row">
                                            <div class="col">
                                                <h6 class="card-title text-uppercase text-muted mb-0">Valor das Prestações</h6>
                                                <span class="h3 font-weight-bold mb-0"> {{ formatarDinheiro(dashboard.valorTotalPrestacoes) }}</span>
                                            </div>
                                            <div class="col-auto">
                                                <div class="text-green">
                                                    <b-icon-cash-coin variant="success" font-scale="2"></b-icon-cash-coin>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- Valor das Taxas -->
                            <div class="col-12 col-md-4 mb-3">
                                <div class="card card-stats">
                                    <div class="card-body">
                                        <div class="row">
                                            <div class="col">
                                                <h6 class="card-title text-uppercase text-muted mb-0">Valor das Taxas</h6>
                                                <span class="h3 font-weight-bold mb-0"> {{ formatarDinheiro(dashboard.valorTotalTaxas) }}</span>
                                            </div>
                                            <div class="col-auto">
                                                <div class="text-green">
                                                    <b-icon-cash-coin variant="success" font-scale="2"></b-icon-cash-coin>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- Data Próximo Vencimento -->
                            <div class="col-12 col-md-4 mb-3">
                                <div class="card card-stats">
                                    <div class="card-body">
                                        <div class="row">
                                            <div class="col">
                                                <h6 class="card-title text-uppercase text-muted mb-0">Data próximo vencimento</h6>
                                                <span class="h3 font-weight-bold mb-0">{{ formatarData(dashboard.dataProximoVencimento) }}</span>
                                            </div>
                                            <div class="col-auto">
                                                <div class="text-green">
                                                    <b-icon-calendar variant="info" font-scale="2"></b-icon-calendar>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- Data Último Pagamento -->
                            <div class="col-12 col-md-4 mb-3">
                                <div class="card card-stats">
                                    <div class="card-body">
                                        <div class="row">
                                            <div class="col">
                                                <h6 class="card-title text-uppercase text-muted mb-0">Data último pagamento</h6>
                                                <span class="h3 font-weight-bold mb-0">{{ formatarData(dashboard.dataUltimoPagamento) }}</span>
                                            </div>
                                            <div class="col-auto">
                                                <div class="text-green">
                                                    <b-icon-calendar variant="info" font-scale="2"></b-icon-calendar>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- Previsão Última Prestação -->
                            <div class="col-12 col-md-4 mb-3">
                                <div class="card card-stats">
                                    <div class="card-body">
                                        <div class="row">
                                            <div class="col">
                                                <h6 class="card-title text-uppercase text-muted mb-0">Previsão última prestação</h6>
                                                <span class="h3 font-weight-bold mb-0">{{ formatarData(dashboard.previsaoUltimaPrestacao) }}</span>
                                            </div>
                                            <div class="col-auto">
                                                <div class="text-green">
                                                    <b-icon-calendar variant="info" font-scale="2"></b-icon-calendar>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- Composição do Contrato (Modelo de Financiamento) -->
                            <div class="col-12 mt-3" v-if="composicaoModelo">
                                <div class="card shadow-sm">
                                    <div class="card-header bg-light py-2">
                                        <h6 class="mb-0">
                                            <b-icon-pie-chart variant="info" class="mr-2"></b-icon-pie-chart>
                                            Composição do Contrato — {{ composicaoModelo.modelo_nome }}
                                        </h6>
                                    </div>
                                    <div class="card-body py-2">
                                        <div class="row mb-2">
                                            <div class="col-md-3">
                                                <small class="text-muted d-block">Valor Base</small>
                                                <strong>{{ formatarDinheiro(dashboard.valorBaseLote) }}</strong>
                                            </div>
                                            <div class="col-md-3" v-if="dashboard.valorDescontoCondicao > 0">
                                                <small class="text-muted d-block">Desc. Condição</small>
                                                <strong class="text-warning">-{{ formatarDinheiro(dashboard.valorDescontoCondicao) }}</strong>
                                            </div>
                                            <div class="col-md-3" v-if="dashboard.valorDescontoAvulso > 0">
                                                <small class="text-muted d-block">Desc. Avulso</small>
                                                <strong class="text-warning">-{{ formatarDinheiro(dashboard.valorDescontoAvulso) }}</strong>
                                            </div>
                                            <div class="col-md-3">
                                                <small class="text-muted d-block">Valor Venda</small>
                                                <strong class="text-success">{{ formatarDinheiro(dashboard.valorTotalContrato) }}</strong>
                                            </div>
                                        </div>
                                        <table class="table table-sm table-bordered mb-0">
                                            <thead class="thead-light">
                                                <tr>
                                                    <th>Componente</th>
                                                    <th class="text-right">%</th>
                                                    <th class="text-right">Valor</th>
                                                    <th class="text-center">Parcelas</th>
                                                    <th class="text-right">Valor/Parcela</th>
                                                    <th v-if="temColunaTotalJuros" class="text-right">Total a pagar</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(comp, idx) in composicaoModelo.componentes" :key="'comp-'+idx" :class="{'table-info': comp.residual}">
                                                    <td>{{ comp.descricao }}</td>
                                                    <td class="text-right">{{ parseFloat(comp.percentual).toFixed(2) }}%</td>
                                                    <td class="text-right">{{ formatarDinheiro(comp.valor) }}</td>
                                                    <td class="text-center">{{ comp.qtd_parcelas }}</td>
                                                    <td class="text-right">
                                                        {{ formatarDinheiro(comp.valor_parcela) }}
                                                        <small v-if="(comp.juros_remuneratorios_taxa || 0) > 0" class="text-info d-block">c/ juros {{ comp.juros_remuneratorios_taxa }}% a.m.</small>
                                                        <small v-if="comp.juros_remuneratorios_tipo === 'sac'" class="text-muted d-block">(1ª parcela; SAC – parcelas decrescentes)</small>
                                                    </td>
                                                    <td v-if="temColunaTotalJuros" class="text-right">
                                                        <template v-if="(comp.valor_total_com_juros || 0) > 0">{{ formatarDinheiro(comp.valor_total_com_juros) }}</template>
                                                        <span v-else class="text-muted">-</span>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <small class="text-muted mt-1 d-block" v-if="composicaoModelo.condicao_descricao">
                                            Condição: {{ composicaoModelo.condicao_descricao }}
                                            <span v-if="composicaoModelo.condicao_desconto > 0">(desconto {{ composicaoModelo.condicao_desconto }}%)</span>
                                        </small>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- Card: Saldo Devedor Atualizado com Correção Monetária -->
                        <div class="row mt-4">
                            <div class="col-12">
                                <div class="card shadow-sm">
                                    <div class="card-header bg-info text-white">
                                        <h5 class="mb-0">Saldo Devedor Atualizado</h5>
                                        <small>Valores com correção monetária aplicada</small>
                                    </div>
                                    <div class="card-body">
                                        <div class="row">
                                            <div class="col-6 col-md-4 text-center mb-3">
                                                <small class="text-muted d-block mb-2">Total Financiado</small>
                                                <h4 class="mb-0">{{ formatarDinheiro(saldoDevedor.valor_total_financiado) }}</h4>
                                            </div>
                                            <div class="col-6 col-md-4 text-center mb-3">
                                                <small class="text-muted d-block mb-2">Valor Pago</small>
                                                <h4 class="mb-0 text-success">{{ formatarDinheiro(saldoDevedor.valor_pago) }}</h4>
                                            </div>
                                            <div class="col-6 col-md-4 text-center mb-3">
                                                <small class="text-muted d-block mb-2">Saldo Devedor</small>
                                                <h4 class="mb-0 text-danger">{{ formatarDinheiro(saldoDevedor.saldo_devedor) }}</h4>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <!-- Gráfico de Pizza -->
                        <div class="row mt-4">
                            <div class="col-md-6 offset-md-3" v-if="dataPie !== null">
                                <grafico-de-pizza :data="dataPie" :options="optionsPie" :key="chaveAtualizacao" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapActions } from 'vuex'

import api from '@/api/app.api.js'

import GraficoDePizza from '@/components/GraficoDePizza.vue'

import Util from '@/util.js'

export default {
    components: {
        GraficoDePizza
    },
    props: {
        fichaId: {
            type: Number,
            required: true
        }
    },
    computed: {
        composicaoModelo() {
            const snapshot = this.dashboard.modeloFinanciamentoSnapshot;
            if (!snapshot) return null;
            try {
                return typeof snapshot === 'string' ? JSON.parse(snapshot) : snapshot;
            } catch (e) {
                return null;
            }
        },
        temColunaTotalJuros() {
            const comps = this.composicaoModelo && this.composicaoModelo.componentes;
            if (!comps || !comps.length) return false;
            return comps.some(c => (c.valor_total_com_juros || 0) > 0);
        }
    },
    data() {
        return {
            dashboard: {
                valorTotalContrato: 0,
                valorTotalEntrada: 0,
                valorTotalPrestacoes: 0,
                valorTotalTaxas: 0,
                dataProximoVencimento: '',
                dataUltimoPagamento: '',
                previsaoUltimaPrestacao: '',
                valorBaseLote: 0,
                valorDescontoCondicao: 0,
                valorDescontoAvulso: 0,
                modeloFinanciamentoSnapshot: null
            },
            saldoDevedor: {
                valor_total_financiado: 0,
                valor_correcoes_aplicadas: 0,
                valor_pago: 0,
                saldo_devedor: 0
            },
            optionsPie: null,
            dataPie: null,
            chaveAtualizacao: 0
        };
    },
    mounted() {
        this.obterDashboard()
        this.obterResumoFinanciamento()
        this.obterSaldoDevedorAtualizado()
    },
    methods: {
        ...mapActions('msgErro', { exibirMsgErro: 'exibirMsgErro' }),
        ...mapActions('msgSucesso', { exibirMsgSucesso: 'exibirMsgSucesso' }),
        obterDashboard() {
            api.obterDashboard(this.fichaId)
                .then(response => {
                    this.dashboard = response.data
                })
                .catch(() => {
                    this.exibirMsgErro()
                });
        },
        obterResumoFinanciamento() {
            api.obterResumoFinanciamento(this.fichaId)
                .then(response => {
                    const dados = response.data

                    this.dataPie = {
                        labels: ['Prestação Pagas', 'Prestações em Aberto', 'Prestações Atrasadas'],
                        datasets: [
                            {
                                backgroundColor: ['#41B883', '#00D8FF', '#E46651'],
                                data: [dados.valorTotalBoletosPagos, dados.valorTotalBoletosAbertos, dados.valorTotalBoletosAtrasados]
                            }
                        ]
                    }

                    this.optionsPie = {
                        tooltips: {
                            enabled: true,
                            callbacks: {
                                label: function (tooltipItem, data) {
                                    let dataset = data.datasets[tooltipItem.datasetIndex]
                                    let value = dataset.data[tooltipItem.index]
                                    return Util.formatarDinheiro(value)
                                }
                            }
                        }
                    }

                    this.chaveAtualizacao++
                })
                .catch(() => {
                    this.exibirMsgErro()
                });
        },
        obterSaldoDevedorAtualizado() {
            api.obterSaldoDevedorAtualizado(this.fichaId)
                .then(response => {
                    this.saldoDevedor = response.data
                })
                .catch(() => {
                    this.exibirMsgErro('Erro ao carregar saldo devedor')
                });
        },
        formatarDinheiro(valor) {
            return Util.formatarDinheiro(valor)
        },
        converterDataUsParaBr(data) {
            return Util.converterDataUsParaBr(data)
        },
        formatarData(data) {
            if (!data || data === '' || data === null) {
                return 'Nenhum pagamento'
            }
            
            // Se for string com formato ISO ou timestamp
            if (typeof data === 'string') {
                // Remover parte do timestamp se houver (T00:00:00.000000Z)
                const dataLimpa = data.split('T')[0]
                return Util.converterDataUsParaBr(dataLimpa)
            }
            
            return Util.converterDataUsParaBr(data)
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/pages/Contrato/Components/Dashboard.vue